import { IPayload } from 'models/Global'
import {
  IGetOvertimePoliciesParams,
  IOvertimePolicy,
  IPutOvertimePolicyParams,
  IPostOvertimePolicyParams,
} from 'models/OvertimePolicy'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class OvertimePoliciesApi {
  constructor(private axios: AxiosService) {}

  getOvertimePolicies = async (params?: IGetOvertimePoliciesParams) => {
    const response = await this.axios.get<IPayload<IOvertimePolicy[]>>(
      Endpoints.getOvertimePolicies,
      params
    )
    return response
  }

  getOvertimePolicy = async (id: number) => {
    const response = await this.axios.get<IPayload<IOvertimePolicy>>(
      Endpoints.getOvertimePolicy(id)
    )
    return response
  }

  putOvertimePolicy = async (id: number, params?: IPutOvertimePolicyParams) => {
    const response = await this.axios.put<IPayload<IOvertimePolicy>>(
      Endpoints.putOvertimePolicy(id),
      params
    )
    return response
  }

  postOvertimePolicy = async (params: IPostOvertimePolicyParams) => {
    const response = await this.axios.post<IPayload<IOvertimePolicy>>(
      Endpoints.postOvertimePolicy,
      params
    )
    return response
  }

  expireOvertimePolicy = async (id: number) => {
    const response = await this.axios.put<IPayload<IOvertimePolicy>>(
      Endpoints.putOvertimePolicyExpire(id),
      {}
    )
    return response
  }
}
